import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { tenantCommand } from '../../model/const/command';
import { Contact } from '../../model/contact';
import { PrintGdprCommandHandler } from '../../service/command/print-gdpr-command-handler.service';
import { SendRegistrationKeyCommandHandler } from '../../service/command/send-registration-key-command-handler.service';
import { TenantCommandHandlerResolver } from '../../service/command/tenant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { ContactService } from '../../service/data/contact.service';
import { UserAccountService } from '../../../common/service/user-account.service';
import { standardCommand } from '../../../core/model/command';

@Component({
    selector: 'app-contact-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [TenantCommandHandlerResolver, PrintGdprCommandHandler, SendRegistrationKeyCommandHandler],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactManagerComponent extends PagedObjectManagerComponent<Contact> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    contactDataService: ContactService,
    dispatcher: CommandDispatcher,
    handlerResolver: TenantCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    private _userAccount: UserAccountService
  ) {
    super(contactDataService, messageService, navigationService, dispatcher, handlerResolver);

    this.menuDefinition = [new MenuItemDefinition('COMMON.EXCEL_EXPORT', tenantCommand.export)];
    this.preferencesKey = 'rent.contact.list';

    this.AddSubscription(
      this._userAccount.current.subscribe({
        next: account => {
          if (account.hasContactWriteAccess()) {
            this.allowNew = true;
          } else {
            this.allowNew = false;
          }
          if (account.hasContactWriteAccess()) {
            this.addContextMenuItemDefinition('TENANT.COMMAND.SEND_REGISTRATION_KEY', tenantCommand.sendRegistrationKey);
          }
          if (account.hasContactWriteAccess()) {
            this.addContextMenuItemDefinition('TENANT.COMMAND.CREATE_FAULT_NOTIFICATION', tenantCommand.showFaultNotification);
          }
          this.addContextMenuItemDefinition('TENANT.COMMAND.PRINT_GDPR', tenantCommand.printGDPR);
          if (account.hasContactWriteAccess()) {
            this.addContextMenuItemDefinition('TENANT.COMMAND.CLEANUP_DATA', tenantCommand.cleanupData);
          }
          this.addContextMenuItemDefinition('TENANT.COMMAND.SHOW_INVOICE', tenantCommand.showInvoices);
          if (account.hasContactWriteAccess()) {
            this.addContextMenuItemDefinition('TENANT.COMMAND.REPAY_BALANCE', tenantCommand.repayBalance);
          }
          if (account.hasContactWriteAccess()) {
            this.addContextMenuItemDefinition('TENANT.COMMAND.MOVE_BALANCE', tenantCommand.moveBalance);
          }
        },
      })
    );

    this.columnDefinition = columnDefinitionService.create('Tenant');

    this.title = 'TENANT.LIST_HEADER';
  }

  ngOnInit() {
    this.AddSubscription(
      (<ContactService>this.dataService).getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'TENANT.CONTACT_NUMBER',
            'number',
            definition.number,
            null,
            definition.selectedFields.includes('number')
          ),
          new FilterDefinitionItem('TENANT.NAME', 'name', definition.name, null, definition.selectedFields.includes('name')),
          new FilterDefinitionItem('TENANT.EMAIL', 'email', definition.email, null, definition.selectedFields.includes('email')),
          new FilterDefinitionItem('TENANT.PHONE', 'phone', definition.phone, null, definition.selectedFields.includes('phone')),
          new FilterDefinitionItem(
            'TENANT.CIVIC_ORG_NUMBER',
            'contactIdentification',
            definition.contactIdentification,
            null,
            definition.selectedFields.includes('contactIdentification')
          ),
        ];
      })
    );

    this.AddSubscription(
      this._userAccount.current.subscribe({
        next: account => {
          if (account.hasContactWriteAccess()) {
            this.addContextMenuItemDefinition('EDIT_BTN', standardCommand.edit);
            this.addContextMenuItemDefinition('DELETE_BTN', standardCommand.delete);
          } else {
            this.addContextMenuItemDefinition('EDIT_BTN', standardCommand.edit);
          }
        },
      })
    );
  }
}
